import React, { lazy } from 'react';
import { Section } from './ui/Section';
export function AcceleratorComparison() {
  const rows = [{
    base: 'Piel sana y equilibrada',
    complete: 'Piel en su mejor versión absoluta'
  }, {
    base: 'Rutina optimizada',
    complete: 'Rutina de alta potencia'
  }, {
    base: 'Activos bien usados',
    complete: 'Arsenal completo de resultados'
  }, {
    base: 'Resultado en semanas',
    complete: 'Transformación visible en 30 días'
  }, {
    base: 'Mantenimiento de por vida',
    complete: 'Plan de 90 días acelerado'
  }];
  const modules = [{
    title: '⚡ MÓDULO 1 — Rutinas de Alta Potencia',
    desc: 'Las rutinas que van más allá de lo básico. Protocolos de luminosidad extrema, anti-edad acelerado y control total del acné adulto. No son rutinas de revista. Son protocolos diseñados para mujeres que ya entienden su piel y quieren resultados visibles en el espejo en menos de 30 días.'
  }, {
    title: '⚡ MÓDULO 2 — El Arsenal de Dispositivos',
    desc: 'Rodillos de jade, gua sha, masajeadores de microcorriente, LED facial, dermapen casero. Qué comprar, qué evitar, cómo usar cada dispositivo para multiplicar por 3 la efectividad de tus activos. Sin riesgos. Sin errores. Con resultados de cabina en casa.'
  }, {
    title: '⚡ MÓDULO 3 — Resultados de Clínica en Casa',
    desc: 'Los tratamientos que las clínicas estéticas cobran a 150-300€ la sesión, replicados en casa con productos accesibles en España. Peeling químico casero, mesoterapia sin agujas, lifting facial con técnica manual. Paso a paso. Sin improvisación.'
  }, {
    title: '⚡ MÓDULO 4 — El Protocolo Anti-Edad Acelerado',
    desc: 'Para mujeres de 35 en adelante que quieren resultados reales y visibles. No promesas de crema. Un protocolo científico con los activos más potentes del mercado, en el orden correcto, con la frecuencia correcta y combinados de forma óptima para que tu piel tenga 10 años menos en el espejo.'
  }, {
    title: '⚡ MÓDULO 5 — Tu Plan de 90 Días',
    desc: 'Un calendario semana a semana durante 90 días con exactamente qué hacer cada día para ver la transformación más grande que tu piel haya experimentado. Sin adivinar. Sin improvisar. Sin plateaus.'
  }];
  const forWho = ['Quieres resultados que la gente note y pregunte qué te has hecho', 'Tienes más de 30 años y quieres retrasar el envejecimiento de forma real', 'Has gastado dinero en clínicas y quieres replicar esos resultados en casa', 'Eres de las que cuando hace algo, lo hace bien del todo', 'Entiendes que 6€ más ahora pueden ahorrarte 300€ en clínica este año'];
  return <Section variant="upsell" data-id="element-25">
      <div className="text-center mb-12" data-id="element-26">
        <h2 className="font-display text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-27">
          Y HAY UNA RAZÓN MUY CLARA PARA ELLO
        </h2>
        <p className="font-body text-xl text-brand-bgAlt max-w-3xl mx-auto leading-relaxed mb-6" data-id="element-28">
          Cuando compras la Oferta Base, obtienes un sistema extraordinario.
          Auditas tu piel. Reparas tu barrera. Construyes tu rutina definitiva.
        </p>
        <p className="font-body text-xl text-white font-bold max-w-3xl mx-auto mb-6" data-id="element-29">
          Pero hay un nivel más allá.
        </p>
        <p className="font-body text-lg text-brand-bgAlt max-w-3xl mx-auto leading-relaxed mb-12" data-id="element-30">
          Un nivel donde tu piel no solo está sana — está en su mejor versión
          absoluta. Donde no solo eliminas lo que daña — potencias al máximo lo
          que transforma. Donde no solo tienes una rutina — tienes un sistema de
          alta potencia que trabaja mientras duermes.
        </p>
        <h3 className="font-display text-2xl md:text-4xl font-bold text-brand-gold mb-4" data-id="element-31">
          Ese nivel se llama PIEL SIN FILTROS™.
        </h3>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-12 mb-16" data-id="element-32">
        <h4 className="font-heading text-2xl font-bold text-white mb-8 text-center" data-id="element-33">
          🔥 ¿QUÉ ES PIEL SIN FILTROS™?
        </h4>
        <p className="font-body text-brand-bgAlt text-center max-w-2xl mx-auto mb-12" data-id="element-34">
          PIEL SIN FILTROS™ — El Sistema de Alta Potencia es el programa
          avanzado que completa EL AUDITOR DE SKINCARE™ llevándolo al siguiente
          nivel de resultados. Mientras los 5 tomos te dan la base científica
          perfecta, PIEL SIN FILTROS™ te da las herramientas de alta potencia
          que usan las mujeres con la piel más envidiable — sin pagar precios de
          clínica estética.
        </p>

        <h4 className="font-heading text-xl font-bold text-brand-gold mb-6" data-id="element-35">
          📦 QUÉ INCLUYE PIEL SIN FILTROS™:
        </h4>
        <div className="space-y-6 mb-12" data-id="element-36">
          {modules.map((mod, i) => <div key={i} className="bg-black/20 rounded-xl p-6" data-id="element-37">
              <h5 className="font-heading text-lg font-bold text-white mb-2" data-id="element-38">
                {mod.title}
              </h5>
              <p className="font-body text-brand-bgAlt text-sm leading-relaxed" data-id="element-39">
                {mod.desc}
              </p>
            </div>)}
        </div>

        {/* Collage Piel Sin Filtros™ */}
        <figure className="my-12" data-id="element-40">
          <img src="https://cdn.magicpatterns.com/uploads/8KVeSHdaTU67PQ8iCd4ZLX/Diseno_sin_titulo_(2).webp" alt="Vista previa de PIEL SIN FILTROS™: Protocolos avanzados, suplementación y calendario de cristalización" width={1000} height={750} loading="lazy" decoding="async" className="w-full" style={{
          maxWidth: '100%',
          borderRadius: '12px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.3)'
        }} data-id="element-41" />
          <figcaption className="font-body text-sm text-brand-bgAlt/80 text-center mt-4 italic px-4" data-id="element-42">
            Protocolos avanzados: El Método de las 7 Capas, suplementación con
            evidencia científica y el calendario de cristalización de 4 semanas.
          </figcaption>
        </figure>

        <h4 className="font-heading text-xl font-bold text-white mb-6 text-center" data-id="element-43">
          💬 POR QUÉ DEBERÍAS ELEGIR ESTA OFERTA:
        </h4>
        <div className="overflow-x-auto mb-12" data-id="element-44">
          <table className="w-full min-w-[600px] border-collapse bg-black/20 rounded-xl overflow-hidden" data-id="element-45">
            <thead data-id="element-46">
              <tr data-id="element-47">
                <th className="text-left p-4 border-b border-white/10 text-brand-bgAlt font-heading font-medium w-1/2" data-id="element-48">
                  Con Oferta Base
                </th>
                <th className="text-left p-4 border-b border-white/10 text-brand-gold font-heading font-bold w-1/2" data-id="element-49">
                  Con PIEL SIN FILTROS™
                </th>
              </tr>
            </thead>
            <tbody data-id="element-50">
              {rows.map((row, i) => <tr key={i} className="hover:bg-white/5 transition-colors" data-id="element-51">
                  <td className="p-4 border-b border-white/10 text-brand-bgAlt/80 font-body text-sm" data-id="element-52">
                    {row.base}
                  </td>
                  <td className="p-4 border-b border-white/10 text-white font-body font-medium text-sm" data-id="element-53">
                    {row.complete}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <h4 className="font-heading text-xl font-bold text-brand-gold mb-6" data-id="element-54">
          🎯 ESTA OFERTA ES PARA TI SI:
        </h4>
        <ul className="space-y-4 mb-12" data-id="element-55">
          {forWho.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-56">
              <span className="text-brand-gold shrink-0 mt-0.5" data-id="element-57">✅</span>
              <span className="font-body text-white" data-id="element-58">{item}</span>
            </li>)}
        </ul>

        <div className="bg-black/40 border border-brand-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-59">
          <h4 className="font-heading text-xl font-bold text-white mb-4" data-id="element-60">
            💰 PRECIO:
          </h4>
          <div className="font-body text-brand-bgAlt mb-2" data-id="element-61">
            Valor real del sistema completo: 97.99€
          </div>
          <div className="font-body text-brand-bgAlt mb-6" data-id="element-62">
            Oferta Base: 13.99€
          </div>

          <p className="font-body text-white font-medium mb-6" data-id="element-63">
            Solo 6€ más sobre la Oferta Base. Por todo un sistema de alta
            potencia que normalmente cuesta 10 veces más.
          </p>

          <div className="font-heading text-4xl font-black text-brand-gold mb-8" data-id="element-64">
            19.99€ — TODO INCLUIDO
          </div>

          <a href="https://pagos.digipromarket.com/cart/56484211622214:1" target="_blank" rel="noopener noreferrer" className="font-heading w-full bg-brand-gold hover:bg-yellow-500 text-brand-upsell font-bold text-lg py-4 px-6 rounded-xl transition-transform hover:scale-[1.02] active:scale-[0.98] text-center block mb-6" data-id="element-65">
            → SÍ, QUIERO PIEL SIN FILTROS™ + EL AUDITOR COMPLETO
          </a>

          <div className="font-body text-brand-bgAlt text-sm mb-6" data-id="element-66">
            ⚡ Acceso inmediato a todo el sistema — Los 5 Tomos + 3 Bonos + PIEL
            SIN FILTROS™
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-xs text-brand-bgAlt/60 font-medium" data-id="element-67">
            <span className="flex items-center gap-1" data-id="element-68">🔒 Pago 100% seguro</span>
            <span className="flex items-center gap-1" data-id="element-69">🛡️ Garantía 7 días</span>
            <span className="flex items-center gap-1" data-id="element-70">
              ⚡ Acceso en 5 minutos
            </span>
          </div>
        </div>
      </div>
    </Section>;
}